import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHatGraduation = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M31 19V24",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 21L10 16L20 11L30 16L20 21Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 17.5V26C13 27.657 16.134 29 20 29C23.866 29 27 27.657 27 26V17.5",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		})
	]
});
const ForwardRef = forwardRef(SvgHatGraduation);
export default ForwardRef;
